import { useEffect } from 'react'

declare global {
  interface Window {
    fbAsyncInit(): void
    FB: any
  }
}

/**
 * See FB docs
 *
 * https://developers.facebook.com/docs/javascript/quickstart
 */
export const useFbAsyncInit = (appId?: string | null) => {
  useEffect(() => {
    if (!appId) return

    window.fbAsyncInit = () => {
      window.FB.init({
        appId,
        oauth: true,
        cookie: true,
        version: 'v11.0',
        xfbml: true,
      })
    }
  }, [appId])
}

export const FbSdkScript = () => {
  return (
    <script
      async
      defer
      // @ts-ignore FB docs say to do this.
      crossOrigin='anonymous'
      src='https://connect.facebook.net/en_US/sdk.js'
    />
  )
}

export const getFacebookAccessToken = async (): Promise<{ accessToken: string }> => {
  try {
    return await getFacebookLoginStatus()
  } catch {
    return await loginToFacebook()
  }
}

export type FacebookUser = {
  id: string
}
export const getFacebookUser = () =>
  new Promise<FacebookUser>((resolve) => {
    window.FB.api('/me', 'get', (response: FacebookUser) => {
      resolve(response)
    })
  })

type FacebookLogin = {
  status: string
  authResponse: {
    accessToken: string
  }
}

const getFacebookLoginStatus = () =>
  new Promise<FacebookLogin['authResponse']>((resolve, reject) => {
    window.FB.getLoginStatus(({ status, authResponse }: FacebookLogin) => {
      if (status === 'connected') {
        resolve(authResponse)
      } else {
        reject()
      }
    })
  })

const loginToFacebook = () =>
  new Promise<FacebookLogin['authResponse']>((resolve, reject) => {
    window.FB.login(({ status, authResponse }: FacebookLogin) => {
      if (status === 'connected') {
        resolve(authResponse)
      } else {
        reject()
      }
    })
  })
